import { jsx as _jsx } from "react/jsx-runtime";
import { InsulinReminderModalForm, Modal } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { usePatientId } from "@madmedical/user";
import { useCreateInsulinReminderMutation } from "../api";
const CreateInsulinReminderModalForm = ({ open, onClose }) => {
    const { patientId } = usePatientId();
    const [createReminder] = useCreateInsulinReminderMutation();
    const formatFirst = (value) => {
        const now = new Date(new Date().setHours(0, 0, 0, 0));
        const hour = value.split(":")[0];
        const min = value.split(":")[1];
        now.setHours(Number(hour));
        now.setMinutes(Number(min));
        const offsetDate = new Date(now);
        return offsetDate;
    };
    return (_jsx(Modal, Object.assign({ open: open, size: "xs", onClose: onClose }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                patientId,
                firstOccurrence: new Date(),
                comment: null,
            }, mutation: (value) => createReminder(Object.assign(Object.assign({}, value), { firstOccurrence: formatFirst(value.firstOccurrence.toString()) })), resetOnSuccess: true }, { children: ({ submitForm, isSuccess }) => (_jsx(InsulinReminderModalForm, { isSuccess: isSuccess, onClose: onClose, onSubmitPress: submitForm })) })) })));
};
export default CreateInsulinReminderModalForm;
